import { useAppSelector } from "features/common/hooks/useReduxHooks";
import { ShopResponse } from "features/common/interfaces/apis/responses/shops/ShopResponse.d";
import { ApiUserResponse } from "features/common/interfaces/apis/responses/users/UserResponse.d";
import { request } from "libs/axios";
import { useQuery } from "react-query";

export const useShowApiUserApi = (id: number | null) => {
  const { currAppToken } = useAppSelector((state) => state.appsAuth);

  return useQuery(
    [`ShowApiUser`, id],
    () => {
      return request<ApiUserResponse>({
        url: `/auth/api-users/${id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${currAppToken}`,
        },
      });
    },
    {
      select: (data) => {
        return data.data.data;
      },
      refetchOnWindowFocus: false,
    }
  );
};
